<div class="layerContainer">
  <tun-home-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.HOME"></tun-home-panel>
  <tun-calendars-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.CALENDAR"></tun-calendars-panel>
  <tun-music-channels-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.MUSIC_CHANNEL"></tun-music-channels-panel>
  <tun-playlists-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.PLAYLIST"></tun-playlists-panel>
  <tun-search-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.SEARCH"></tun-search-panel>
  <tun-settings-panel class="layer" *ngIf="(selectedTab$ | async) == TunifyV5Tab.SETTINGS"></tun-settings-panel>
</div>
